/**
 * 服务表单配置 Hook
 * 提供创建和编辑服务表单字段的函数
 */

import type { FormItemConfig } from "@ms/shared-components/comps/CompsForm";
import { buildBaseServiceFormFields } from "../config/modalServiceConfig";

/**
 * 创建服务表单字段配置
 */
export const useServiceFormConfig = () => {
  /**
   * 创建服务表单字段
   */
  const createServiceFormFields = (): FormItemConfig[] =>
    buildBaseServiceFormFields();

  /**
   * 编辑服务表单字段配置（不包含 name 字段，因为它是唯一标识）
   */
  const createEditServiceFormFields = (): FormItemConfig[] =>
    createServiceFormFields().filter((field) => field.name !== "service_name");

  return {
    createServiceFormFields,
    createEditServiceFormFields,
  };
};

/**
 * 导出函数以便直接使用（向后兼容）
 */
export const createServiceFormFields = (): FormItemConfig[] =>
  buildBaseServiceFormFields();

export const createEditServiceFormFields = (): FormItemConfig[] =>
  createServiceFormFields().filter((field) => field.name !== "service_name");

